module.exports = __webpack_public_path__ + "static/media/solesshpe.60cfdfb2.svg";